require('./globalPositionSavingsSection.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @components
const GlobalPositionTotalBalance = require('components/globalPosition/globalPositionTotalBalance/globalPositionTotalBalance');
const GlobalPositionECard = require('components/globalPosition/globalPositionECard/globalPositionECard');
const GlobalPositionAccounts = require('components/globalPosition/globalPositionAccounts/globalPositionAccounts');
const GlobalPositionSavings = require('components/globalPosition/globalPositionSavings/globalPositionSavings');
const WebappRender = require('components/conditionalRender/webappRender')
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const LinkToPreferences = require('../shared/linkToPreferences');

// @constants
const GLOBAL_POSITION_BOXES = require('constants/globalPositionBoxes');
const { SAVINGS } = require('constants/flagBasedFeatures');


class GlobalPositionSavingsSection extends React.Component {
    hasShowableECards() {
        const { immCards } = this.props;
        const hasShowableECards = immCards.getIn(['ecard', 'byOrder']).filter(cardId => {
            const immCard = immCards.getIn(['byId', cardId]);
            return immCard.get('visibleinPG'); // true if eCard is valid, active and has 'EN VIGOR' state.
        });
        return hasShowableECards.size;
    }

    render() {
        const {
            immCards,
            immAccounts,
            immGlobalPosition,
            landingBoxes,
            isBalanceDrawn
        } = this.props;
        const immSavings = immGlobalPosition.get('savings');
        const accountsNotEmpty = immAccounts.get('excludedCards') !== immAccounts.get('byId').size;
        const savingsNotEmpty = !!immSavings.get('allSavings').size;
        const ecardsNotEmpty = this.hasShowableECards();

        const accountBalance = isBalanceDrawn
            ? immAccounts.get('balanceDrawnForGlobalPosition')
            : immAccounts.get('balanceForGlobalPosition')

        const savingsAmounts = accountBalance.concat(
            immCards.get('ecard').get('availableBalanceForPG'),
            immSavings.get('totalAvailableBalance')
        );

        let savingsAndInvestmentsSection;

        if (accountsNotEmpty || savingsNotEmpty || ecardsNotEmpty) {
            let globalPositionAccounts;
            let globalPositionECard;
            let globalPositionSavings;

            // check for specific subsections
            if (accountsNotEmpty) {
                const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.ACCOUNT);
                globalPositionAccounts = (
                    <div
                        className="global-position-savings-section__subsection"
                        id="global-position-accounts"
                    >
                        <GlobalPositionAccounts
                            id={GLOBAL_POSITION_BOXES.ACCOUNT}
                            immAccountsByOrder={immAccounts.get('byOrder')}
                            immAccountsById={immAccounts.get('byId')}
                            balance={accountBalance}
                            excludedItems={immAccounts.get('excludedAccounts')}
                            expanded={expanded}
                            isBalanceDrawn={isBalanceDrawn}
                        />
                    </div>
                );
            }
            if (ecardsNotEmpty) {
                const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.ECARD);
                globalPositionECard = (
                    <div
                        className="global-position-savings-section__subsection"
                        id="global-position-ecards"
                    >
                        <GlobalPositionECard
                            id={GLOBAL_POSITION_BOXES.ECARD}
                            immCards={immCards}
                            expanded={expanded}
                            hasShowableECards={this.hasShowableECards()}
                        />
                    </div>
                );
            }
            if (savingsNotEmpty) {
                const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.SAVINGS);
                globalPositionSavings = (
                    <FeatureTogglingRender notAllowedProductKey={SAVINGS} >
                        <div
                            className="global-position-savings-section__subsection"
                            id="global-position-savings"
                        >
                            <GlobalPositionSavings
                                id={GLOBAL_POSITION_BOXES.SAVINGS}
                                immSavings={immSavings}
                                expanded={expanded}
                            />
                        </div>
                    </FeatureTogglingRender>
                );
            }

            savingsAndInvestmentsSection = (
                <div className="global-position-savings-section__section">
                    <h3 className="global-position-savings-section__section-title">
                        <FormattedText value="myGlobalPosition-myGlobalPosition_savingAccounts" />
                    </h3>
                    <WebappRender>
                        <div className="global-position-savings-section__link-settings hidden-xs">
                            <span className="global-position-savings-section__link-settings-text">
                                <FormattedText value="myGlobalPosition-settings" />
                            </span>
                            <LinkToPreferences />
                        </div>
                    </WebappRender>
                    {globalPositionAccounts}
                    {globalPositionSavings}
                    {globalPositionECard}
                    <GlobalPositionTotalBalance
                        translationKey="myGlobalPosition-myGlobalPosition_totalBalanceSavings"
                        immAmounts={savingsAmounts}
                        iconClass="default"
                        keepSign={true}
                    />
                </div>
            );
        }

        return (
            <div className="global-position-savings-section">
                {savingsAndInvestmentsSection}
            </div>
        );
    }
}

GlobalPositionSavingsSection.propTypes = {
    immCards: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    landingBoxes: PropTypes.object.isRequired,
    isBalanceDrawn: PropTypes.object.isRequired,
};

module.exports = GlobalPositionSavingsSection;
